import { useAppDescriptions } from '../product-descriptions';

import { EDITIONS } from './common/edition-options';
import { ProductCard } from './common/product-card';
import { useProductCardData } from './common/use-product-card-data';

export const JiraProductCard = () => {
	const { iconUrl, description } = useAppDescriptions().jira;
	return (
		<ProductCard
			{...useProductCardData('jira')}
			title="Jira"
			iconUrl={iconUrl}
			description={description}
			unitType="user"
			editions={EDITIONS}
		/>
	);
};
